export const bannerWords = [
  "Artificial Intelligence",
  "Quantum Computing",
  "Cybersecurity",
  "Data Science",
  "Computational Genomics",
  "Fintech",
];
